// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2pV5Pr1wrZzAa0ZwTkavgP{-ms-overflow-style:none;scrollbar-width:none}._2pV5Pr1wrZzAa0ZwTkavgP::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hideScrollbar": "_2pV5Pr1wrZzAa0ZwTkavgP"
};
module.exports = ___CSS_LOADER_EXPORT___;
